/**
 * Bundle Products Data JavaScript
 * 
 * This file handles the functionality for bundle products on the Greats Shopify theme.
 * It manages:
 * 1. Add to cart functionality for bundle products
 * 2. Cart state updates and mini-cart display
 * 3. Dynamic bundle container visibility based on selected color/gender
 */

document.addEventListener("DOMContentLoaded", function() { 
    document.querySelectorAll('.bundle-add-to-cart').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        var variantId = this.getAttribute('data-variant-id');
        var productTitle = this.getAttribute('data-product-title'); 
        var originalText = this.textContent;
        
        // Show loading state and disable button to prevent double-clicks
        this.textContent = 'Adding...';
        this.disabled = true; 
        
        // Add product to cart via Shopify AJAX API
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantId,
            quantity: 1
          },
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown) {
            var response = JSON.parse(jqXHR.responseText);  
            button.textContent = originalText;
            button.disabled = false;
          }
        }).done(function(data) { 
          // After successful add to cart, update cart display and show mini-cart
          $.getJSON('/cart.js', function(cart) { 
            if (cart.item_count > 0) {
              $('header .cart').addClass('active_cart');
              $('.cart_count').text(cart.item_count);
            } else {
              $('header .cart').removeClass('active_cart');
              $('.cart_count').text(cart.item_count);
            } 
             
            if (typeof freeGift === 'function') {
              freeGift(cart);
            }
              
            $.get("/cart?view=minicart", function(minicartData) {
              $('#crt').html(minicartData); 
              
              // Trigger cart upsell items if available (cross-selling)
              if (typeof cartUpsellitems === 'function') {
                cartUpsellitems();
              } 
              
              // Show cart overlay and add body classes for styling
              $('body').addClass('cartOpen');
              $('.fullPage').addClass('witmenu'); 
              
              // Restore button to original state
              button.textContent = originalText;
              button.disabled = false; 
            });
          });
        });
      });
    });    
});